// Implements: F-UIX-010
/**
 * The gallery while its first page loads (the mockup's `skel('cards')`): eight card-shaped
 * placeholders. The region is one `role="status"` with the "Cargando…" text, so the load is
 * announced once and the grey bars (hidden from assistive technology) say nothing.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Skeleton } from "../../../shared/ui/atoms/Skeleton";
import styles from "./GallerySkeleton.module.css";

const PLACEHOLDERS = [0, 1, 2, 3, 4, 5, 6, 7] as const;

export function GallerySkeleton(): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={styles.grid} role="status" aria-busy="true">
      <span className={styles.srOnly}>{t("common.state.loading")}</span>
      {PLACEHOLDERS.map((index) => (
        <div key={index} className={styles.card}>
          <Skeleton shape="thumb" />
          <div className={styles.body}>
            <Skeleton shape="line" width="threeQuarters" />
            <Skeleton shape="line" width="half" />
          </div>
        </div>
      ))}
    </div>
  );
}
